import React, { useState, useEffect, useRef } from "react";
import { CubeTransition } from "react-3d-cube-transition";
import "react-3d-cube-transition/dist/index.css";
import axios from "axios";
import "./pagesCss/button.scss";
import Comparateur from "./superServices/Comparateur";
import Formations from "./superServices/Formations";
import Solliciter from "./superServices/Solliciter";
import { useNavigate } from "react-router-dom";
import { getStrapiURL } from "../lib/api";

const OCRView = () => {
  const fileInput = useRef(null);

  const [image, setImage] = useState(null);
  const [lang, setLang] = useState("fr");
  const [showImage, setShowImage] = useState(true);
  const [result, setResult] = useState("");

  const readURI = async (e) => {
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = async function (ev) {
        setImage(ev.target.result);
        setShowImage(false);

        const formData = new FormData();
        formData.append("lang", lang);
        formData.append("image", ev.target.result);

        const res = await axios.post(getStrapiURL("/api/ocrequests/text"),
          formData
        );
        setResult(res.data.text);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onFileChange = async (event) => {
    readURI(event);
  };

  return (
    <>
      <h2>YOCR</h2>
      <p className="lead">
        Copiez le texte contenu dans vos <b>Images</b>
      </p>

      <form id="file-upload-form" className="uploader">
        <input
          id="file-upload"
          type="file"
          name="image"
          accept=".jpeg, .doc, .docx, .xls, .xlsx, .txt, .jpg, .png, .gif, .webp"
          onChange={onFileChange}
        />

        <label for="file-upload" id="file-drag">
          <img id="file-image" src={image} alt="Preview" hidden={showImage} />
          <div id="start">
            <i class="fa fa-download" aria-hidden="true"></i>
            <div>Sélectionnez une image</div>
            {/* <div id="notimage" class="hidden">
              Please select an image
            </div> */}
            <span id="file-upload" className="btn btn-primary">
              Importer
            </span>
          </div>
          <div id="response">
            <div id="messages">
              {" "}
              {!showImage && <span>Résultat:</span>} <p>{result}</p>
            </div>
          </div>
        </label>
      </form>
    </>
  );
};

function SuperService() {
  const [currentFace, setCurrentFace] = useState("front");
  const _handleButtonClick = (face) => {
    setCurrentFace(face);
  };

  const navigate = useNavigate();

  function handleClick() {
    navigate("/");
  }

  return (
    <>
      <CubeTransition
        className="cube-container"
        face={currentFace}
        frontCSS={{ background: "#f5f5f5" }}
        rightCSS={{ background: "#f5f5f5" }}
        leftCSS={{ background: "#f5f5f5" }}
        backCSS={{ background: "#f5f5f5" }}
        topCSS={{ background: "#f5f5f5" }}
        bottomCSS={{ background: "#f5f5f5" }}
        frontPage={<OCRView />}
        leftPage={<Comparateur />}
        rightPage={<Formations />}
        backPage={<p>back</p>}
        topPage={<Solliciter />}
        bottomPage={<p>bottom</p>}
        contentElevation={0}
      />
      <div
        style={{
          position: "absolute",
          bottom: "1vh",
          width: "100vw",
          transform: "translateX(20%)",
        }}
      >
        <button
          style={{ margin: 10 }}
          onClick={() => _handleButtonClick("front")}
          class="border-black no-shadow button_25"
        >
          OCR
        </button>
        <button
          style={{ margin: 10 }}
          onClick={() => _handleButtonClick("left")}
          class="border-black no-shadow button_25"
        >
          Moteur de recherche
        </button>
        <button
          style={{ margin: 10 }}
          onClick={() => _handleButtonClick("right")}
          class="border-black no-shadow button_25"
        >
          Formations
        </button>
        <button
          style={{ margin: 10 }}
          onClick={() => _handleButtonClick("top")}
          class="border-black no-shadow button_25"
        >
          Solliciter un service
        </button>
        <button
          style={{ margin: 10 }}
          onClick={() => handleClick()}
          class="border-black no-shadow button_25"
        >
          Accueil
        </button>
      </div>
    </>
  );
}

export default SuperService;
